import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/api";
import { Reveal, SectionHeading } from "./Reveal";

const WA_CATALOG_LINK = "https://wa.me/c/393924851819";

const SERVICES = [
    {
        num: "01",
        title: "Ricambi originali",
        text: "Oltre 12.000 ricambi e accessori per tutti i tipi di elettrodomestici. Se stai cercando il tuo ricambio, clicca qui…",
        img: "https://images.unsplash.com/photo-1774273177331-4c19e9912071?auto=format&fit=crop&w=900&h=700&q=80",
        alt: "Scaffali con ricambi in magazzino",
        cta: waLink("Ciao CG Service! Sto cercando un ricambio per il mio elettrodomestico: mi può aiutare?"),
        ctaLabel: "Clicca qui",
    },
    {
        num: "02",
        title: "Vendita elettrodomestici",
        text: "I migliori brand di elettrodomestici a prezzi concorrenziali. Scopri le nostre promo del mese.",
        img: "https://images.unsplash.com/photo-1545173168-9f1947eebb7f?auto=format&fit=crop&w=900&h=700&q=80",
        alt: "Fila di lavatrici in negozio",
        catalog: true,
        ctaLabel: "Scopri le promo",
    },
    {
        num: "03",
        title: "Vendita ricambi Folletto",
        text: "Ricambi e accessori originali e compatibili per il tuo Folletto Vorwerk: spazzole, filtri, sacchetti e tanto altro.",
        img: "https://static.prod-images.emergentagent.com/jobs/1d9c6df7-d631-4249-9472-78008ae630ca/images/906e100d93eb3322ddc7e4f91ade03c147ccbe6343dc664639724e8d9f5a16ce.jpeg",
        alt: "Scopa elettrica bianca e verde in una casa",
        catalog: true,
        ctaLabel: "Scopri le offerte",
    },
];

export default function Servizi() {
    return (
        <section id="servizi" className="py-24 md:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="flex flex-wrap items-end justify-between gap-6">
                    <SectionHeading
                        eyebrow="I servizi"
                        title={
                            <>
                                Tre modi in cui
                                <br />
                                ti aiutiamo.
                            </>
                        }
                    />
                    <Reveal delay={0.15}>
                        <p className="max-w-sm text-muted-foreground leading-relaxed">
                            Competenza, qualità, prezzi concorrenziali e
                            cortesia: garantiti dal primo giorno, da trent'anni.
                        </p>
                    </Reveal>
                </div>

                <div className="mt-14 grid md:grid-cols-3 gap-6">
                    {SERVICES.map((s, i) => (
                        <Reveal key={s.num} delay={i * 0.12} className="h-full">
                            <article
                                data-testid={`servizio-${s.num}`}
                                className="group border border-line bg-card h-full"
                            >
                                <div className="overflow-hidden aspect-[4/3]">
                                    <img
                                        src={s.img}
                                        alt={s.alt}
                                        loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                    />
                                </div>
                                <div className="p-7">
                                    <p className="font-mono text-xs text-primary tracking-[0.25em]">
                                        {s.num}
                                    </p>
                                    <h3 className="mt-3 font-display text-2xl font-bold tracking-tight">
                                        {s.title}
                                    </h3>
                                    <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                                        {s.text}
                                    </p>
                                    {s.cta || s.catalog ? (
                                        <a
                                            data-testid={`servizio-cta-${s.num}`}
                                            href={s.catalog ? WA_CATALOG_LINK : s.cta}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="mt-5 inline-flex items-center gap-2 bg-primary text-primary-foreground px-5 py-3 font-display font-bold text-sm tracking-tight hover:bg-primary/90 transition-colors"
                                        >
                                            <MessageCircle className="h-4 w-4" />
                                            {s.ctaLabel}
                                        </a>
                                    ) : null}
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}